import {useQuery} from '@tanstack/react-query'
import {configService} from '@/services/configService'

export const POLICY_CATALOG_QUERY_KEY = ['policy-catalog']

/**
 * `/config/policies` — the full policy CATALOG (every direction × distance band).
 *
 * Not to be confused with `/trips/calculate-policies`, which resolves ONE trip's
 * policy: that one needs a route and a direction, so it can't answer /help's
 * "what are the rules?" question. This one is static reference data — cached for
 * the session and never garbage-collected, like the other config queries.
 */
export function usePolicyCatalog({enabled = true} = {}) {
    return useQuery({
        queryKey: POLICY_CATALOG_QUERY_KEY,
        queryFn: async () => {
            const result = await configService.getPolicyCatalog()
            if (!result.success) throw new Error(result.error)
            return result.data
        },
        enabled,
        staleTime: Infinity,
        gcTime: Infinity,
    })
}

export default usePolicyCatalog
